<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>Ajout d'un Hizb</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="nameHizb"
                    label="Nom"
                    outlined
                    :rules="rule"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="suratName"
                    label="Nom du premier Surate (Français)"
                    :items="suratArray"
                    :rules="rule"
                    item-text="arabic_translated_name"
                    item-value="arabic_translated_name"
                    required
                    outlined
                  />
                </v-col>
                 <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="suratNameEn"
                    label="Nom du premier Surate (Anglais)"
                    :items="suratArray"
                    :rules="rule"
                    item-text="englishName"
                    item-value="englishName"
                    required
                    outlined
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="rangHizb"
                    outlined
                    label="Rang"
                    :rules="rule"
                    type="number"
                    oninput="if(this.value < 1) this.value = 1;"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="numVerset"
                    hide-detailss
                    outlined
                    type="number"
                    oninput="if(this.value < 1) this.value = 1;"
                    label="Numéro Premier Verset"
                    :rules="rule"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="juz"
                    label="Juzz"
                    :items="juzzArray"
                    :rules="rule"
                    item-text="name"
                    item-value="juzId"
                    required
                    outlined
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      class="ml-6 mt-4"
                      color="info"
                      @click="validate"
                      :loading="loadingAddHizb"
                    >
                      Enregistrer
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des Hizb</v-card-title>
      <v-text-field
        style="padding: 15px"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
        :search="search"
      ></v-text-field>
      <v-data-table
        :search="search"
        :loading="isLoadingTables"
        loading-text="Loading..."
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 30],
        }"
        :headers="headers"
        :items="formattedHizbArray"
        class="elevation-1"
      >
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="updateClickIcon(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionAction(item.hizbId)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAddHizb" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir ajouter le Hizb ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="reinitialisationFormulaire()"
            >
              Annuler
            </v-btn>

            <v-btn
              color="info darken-1 "
              text
              @click="ajoutHizb()"
              :loading="loadingAddHizb"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogEditHizb" persistent max-width="800px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Informations Hizb</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="hizb.name"
                        label="Nom"
                        outlined
                        :rules="rule"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="hizb.premierSurateName"
                        label="Surat Français"
                        :items="suratArray"
                        :rules="rule"
                        item-text="arabic_translated_name"
                        item-value="arabic_translated_name"
                        required
                        outlined
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="hizb.premierSurateNameEn"
                        label="Surat English"
                        :items="suratArray"
                        :rules="rule"
                        item-text="englishName"
                        item-value="englishName"
                        required
                        outlined
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="hizb.rank"
                        outlined
                        label="Rang"
                        :rules="rule"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="hizb.premierVersetNumero"
                        hide-details
                        outlined
                        type="number"
                        oninput="if(this.value < 1) this.value = 1;"
                        label="Numero verset"
                        :rules="rule"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="hizb.juzId"
                        label="Juzz"
                        :items="juzzArray"
                        :rules="rule"
                        item-text="name"
                        item-value="juzId"
                        required
                        outlined
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogEditHizb = false">
                Annuler
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="validateChampEdit()"
                :loading="loadingEditHizb"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteHizb" max-width="600">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le Hizb ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogDeleteHizb = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteHizb()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogConfirmEditHizb" max-width="600">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir mettre à jour les informations du Hizb ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogConfirmEditHizb = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="updateHizb()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import { mdiPlus, mdiDeleteOutline, mdiPencil } from "@mdi/js";
import Constant from "@/utils/constants";
import {
  getAllSurat,
  getAllJuzz,
  getAllHizb,
} from "@/views/qorani/services/services";
export default {
  data() {
    return {
      search: "",
      isLoadingTables: false,
      hizbArray: [],
      juz: null,
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
      },
      suratArray: [],
      valid: true,
      rule: [(v) => !!v || "Ce champ est requis"],
      nameHizb: "",
      suratName: "",
      rangHizb: "",
      numVerset: "",
      hizb: {
        name: "",
        premierSurateName: "",
        premierSurateNameEn: "",
        rank: null,
        premierVersetNumero: null,
        juzId: "",
      },
      loadingAddHizb: false,
      dialogAddHizb: false,
      juzzArray: [],
      idHizb: null,
      headers: [
        { text: "Nom", value: "name", align: "center" },
        {
          text: "Nom du premier Surate",
          value: "premierSurateName",
          align: "center",
        },
        {
          text: "Nom du premier Surate en anglais",
          value: "premierSurateNameEn",
          align: "center",
        },
        {
          text: "Numéro Premier Verset",
          value: "premierVersetNumero",
          align: "center",
        },
        { text: "Rang", value: "rank", align: "center" },
        { text: "Juzz", value: "juzName", align: "center" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Suppression", value: "supprimer", align: "center" },
      ],
      dialogDeleteHizb: false,
      dialogEditHizb: false,
      loadingEditHizb: false,
      dialogConfirmEditHizb: false,
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        // this.dialogAddHizb = true;
        this.ajoutHizb();
      }
    },
    reinitialisationFormulaire() {
      this.dialogAddHizb = false;
      this.$refs.form.reset();
    },
    async ajoutHizb() {
      this.loadingAddHizb = true;
      this.hizb.name = this.nameHizb;
      this.hizb.premierSurateName = this.suratName;
      this.hizb.premierSurateNameEn=this.suratNameEn;
      this.hizb.premierVersetNumero = Number(this.numVerset);
      this.hizb.rank = Number(this.rangHizb);
      this.hizb.juzId = this.juz;

      const response = await fetch(Constant.QORANI + "hizb/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.hizb),
      });

      try {
        this.loadingAddHizb = false;
        this.dialogAddHizb = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du juz, veuillez réessayez plus tard, Merci."
        );
        this.loadingAddHizb = false;
        this.dialogAddHizb = false;
      }
    },
    suppressionAction(item) {
      this.idHizbSupprimmer = item;
      // this.dialogDeleteHizb = true;
      this.deleteHizb();
    },
    async deleteHizb() {
      const responseCategorie = await fetch(
        Constant.QORANI + `hizb/delete/${this.idHizbSupprimmer}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        this.dialogDeleteHizb = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du Hizb, veuillez réessayez plus tard, Merci."
        );
        this.dialogDeleteHizb = false;
      }
    },
    updateClickIcon(item) {
      this.dialogEditHizb = true;
      this.hizb = item;
      this.idHizb = item.hizbId;
    },
    validateChampEdit() {
      if (this.$refs.form.validate()) {
        // this.dialogConfirmEditHizb = true;
        this.updateHizb();
      }
    },
    async updateHizb() {
      this.loadingEditHizb = true;
      this.hizb.premierVersetNumero = Number(this.hizb.premierVersetNumero);
      this.hizb.rank = Number(this.hizb.rank);
      const responseCategorie = await fetch(
        Constant.QORANI + `hizb/edit/${this.idHizb}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.hizb),
        }
      );

      try {
        this.loadingEditHizb = false;
        this.dialogConfirmEditHizb = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la mise à jour du juz, veuillez réessayez plus tard, Merci."
        );
        this.loadingEditHizb = false;
        this.dialogConfirmEditHizb = false;
      }
    },
  },
  async created() {
    this.isLoadingTables = true;
    this.suratArray = await getAllSurat();
    this.juzzArray = await getAllJuzz();
    this.hizbArray = await getAllHizb();
    this.isLoadingTables = false;
  },
  computed: {
    formattedHizbArray() {
      return this.hizbArray.map((item) => {
        const juz = this.juzzArray.find(
          (juzItem) => juzItem.juzId === item.juzId
        );
        return {
          ...item,
          juzName: juz ? juz.name : "",
        };
      });
    },
  },
};
</script>
